<template>
  <div v-if="hasValue(value)" class="copyable-table-cell">
    <span class="copyable-table-cell__value" :title="String(value)">
      {{ truncateString(value) }}
    </span>
    <b-button
      :aria-label="`کپی ${label}`"
      class="copyable-table-cell__copy-btn"
      size="sm"
      variant="light"
      @click.stop="copy"
    >
      <b-icon
        :icon="isCopied ? 'check2' : 'clipboard'"
        font-scale="0.9"
      ></b-icon>
    </b-button>
  </div>
  <span v-else>{{ EMPTY_VALUE }}</span>
</template>

<script>
import {
  COPY_FEEDBACK_MS,
  EMPTY_VALUE,
  copyToClipboard,
  hasValue,
  truncateString,
} from "../helpers/copyableHelper";

export default {
  name: "CopyableTableCell",
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      EMPTY_VALUE,
      isCopied: false,
    };
  },
  beforeDestroy() {
    clearTimeout(this._copyTimer);
  },
  methods: {
    hasValue,
    truncateString,
    async copy() {
      await copyToClipboard(this.value);
      this.isCopied = true;
      clearTimeout(this._copyTimer);
      this._copyTimer = setTimeout(() => {
        this.isCopied = false;
      }, COPY_FEEDBACK_MS);
    },
  },
};
</script>

<style scoped>
.copyable-table-cell {
  display: inline-flex;
  align-items: center;
  direction: ltr;
}

.copyable-table-cell__value {
  font-family: monospace;
}

.copyable-table-cell__copy-btn {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-right: 6px;
  border-radius: 50%;
}
</style>
